import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import NewOrder from './pages/NewOrder';
import OrderDetail from './pages/OrderDetail';
import EditOrder from './pages/EditOrder';
import Inventory from './pages/Inventory';
import NewProduct from './pages/NewProduct';
import EditProduct from './pages/EditProduct';
import Customers from './pages/Customers';
import NewCustomer from './pages/NewCustomer';
import CustomerDetail from './pages/CustomerDetail';
import EditCustomer from './pages/EditCustomer';
import Suppliers from './pages/Suppliers';
import NewSupplier from './pages/NewSupplier';
import SupplierDetail from './pages/SupplierDetail';
import EditSupplier from './pages/EditSupplier';
import Deliveries from './pages/Deliveries';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/orders/new" element={<NewOrder />} />
                    <Route path="/orders/:id/edit" element={<EditOrder />} />
                    <Route path="/orders/:id" element={<OrderDetail />} />
                    <Route path="/inventory" element={<Inventory />} />
                    <Route path="/inventory/new" element={<NewProduct />} />
                    <Route path="/inventory/:id/edit" element={<EditProduct />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/customers/new" element={<NewCustomer />} />
                    <Route path="/customers/:id/edit" element={<EditCustomer />} />
                    <Route path="/customers/:id" element={<CustomerDetail />} />
                    <Route path="/suppliers" element={<Suppliers />} />
                    <Route path="/suppliers/new" element={<NewSupplier />} />
                    <Route path="/suppliers/:id/edit" element={<EditSupplier />} />
                    <Route path="/suppliers/:id" element={<SupplierDetail />} />
                    <Route path="/deliveries" element={<Deliveries />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
